$('li.contact-form a').on('click', function (e) {
    e.preventDefault();
    $('.popup-detailed').css('display', 'block');
});